export default {"src":"/_next/static/media/GradientTeal.8be8c5ae.svg","height":303,"width":468,"blurWidth":0,"blurHeight":0};